import { SvgIcon } from "@mui/material";

import { ReactComponent as CheckIcon } from "../../../assets/check-circle.icon.svg";
import { ReactComponent as CrossIcon } from "../../../assets/cross.icon.svg";
import { PasswordPolicy } from "../../../common/interfaces/admin/tenant.interface";
import { checkPasswordRules } from "../../../common/utilities/password-policy/password-policy.util";

import "./style.scss";

interface Props {
    policy: PasswordPolicy | null | undefined;
    password: string;
    id?: string;
}

/**
 * The tenant's password rules as a checklist that updates as the user types
 * (Phase 3). Rendered by the sign-up and change-password screens.
 */
export const PasswordRules = ({ policy, password, id }: Props) => {
    const checks = checkPasswordRules(policy, password);
    return (
        <ul className="password-rules" id={id} aria-label="Password requirements">
            {checks.map(check => (
                <li
                    key={check.label}
                    className={`password-rules__item${check.ok ? " password-rules__item--ok" : ""}`}
                >
                    <SvgIcon
                        component={check.ok ? CheckIcon : CrossIcon}
                        inheritViewBox
                        aria-hidden="true"
                        className="password-rules__icon"
                    />
                    <span>
                        {check.label}
                        <span className="password-rules__state">{check.ok ? " (met)" : ""}</span>
                    </span>
                </li>
            ))}
        </ul>
    );
};
